import styled from 'styled-components/macro';
import { Image } from '~/components';

export const Container = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.dark4};
`;
export const Avatar = styled(Image)`
  height: 100%;
  object-fit: cover;
`;

export const ContainerInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: 1;
  padding: 34px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 15px 19px;
  }
`;

export const DataList = styled.div`
  display: flex;
  font-size: 15px;
  order: 1;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    order: 2;
    flex-direction: column;
    font-size: 12px;
  }
`;

export const DataListItem = styled.div`
  border-right: solid 1px ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.white};
  padding: 0px 15px;
  &:last-child {
    border-color: transparent;
  }
  &:first-child {
    padding-left: 0px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    border: none;
    padding-left: 0px;
    margin-bottom: 5px;
  }
`;

export const DataListItemLabel = styled.span`
  font-family: ${({ theme }) => theme.primaryFontLight};
  margin-right: 6px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: block;
  }
`;

export const DataListItemText = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
`;

export const Name = styled.div`
  font-size: 30px;
  font-weight: 500;
  color: ${({ theme }) => theme.white};
  order: 2;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    order: 1;
    margin-bottom: 20px;
    font-size: 20px;
  }
`;
